
import { useNavigate } from 'react-router-dom';
import { productData } from '../../../mocks/products';

export default function ComparisonCards() {
  const navigate = useNavigate();
  const models = ['core', 'pro', 'style'] as const;

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {models.map((modelKey) => {
            const product = productData[modelKey];
            return (
              <div
                key={modelKey}
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 border border-[#e8e6e3]"
              >
                <div className="relative" style={{ width: '100%', height: '280px' }}>
                  <img
                    src={product.heroImage}
                    alt={product.fullName}
                    title={product.fullName}
                    className="w-full h-full object-contain object-center bg-gradient-to-br from-[#f5f3ef] to-white"
                  />
                  <div className="absolute top-4 left-4">
                    <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/90 backdrop-blur-sm">
                      <span className="text-xs font-bold tracking-wider" style={{ color: product.color }}>
                        {product.label}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="p-6 space-y-4">
                  <div>
                    <h3 className="text-2xl font-bold text-[#1a2332] mb-2" style={{ fontFamily: 'Noto Serif JP, serif' }}>
                      {product.fullName}
                    </h3>
                    <p className="text-sm text-[#4a4a4a] font-medium mb-3">{product.tagline}</p>
                    <p className="text-sm text-[#4a4a4a] leading-relaxed line-clamp-3">{product.description}</p>
                  </div>

                  <div className="border-t border-[#e8e6e3] pt-4">
                    <div className="flex items-baseline gap-2 mb-4">
                      <span className="text-2xl font-bold text-[#1a2332]">¥{product.price.toLocaleString()}</span>
                      <span className="text-xs text-[#4a4a4a]">{product.priceNote}</span>
                    </div>

                    <button
                      onClick={() => { navigate(`/product/${modelKey}`); window.scrollTo(0, 0); }}
                      className="w-full px-6 py-3 rounded-full text-sm font-bold text-white transition-all whitespace-nowrap cursor-pointer"
                      style={{ backgroundColor: product.color }}
                    >
                      詳細を見る
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
